import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { getAvailableServerList } from "@/api/channel";
export default {
  props: {
    value: [String, Array, Number],
    multiple: Boolean,
    filterable: Boolean,
    width: Number,
    readCacheType: Number,
    //不读缓存是1，读缓存是随便只要不等于1就可以
    type: Number,
    //1的时候是单选，不传就是多选
    all: Boolean,
    //是否增加全部区服
    isCache: Boolean
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.label = newVal;
      }
    }
  },
  data: function data() {
    return {
      serverList: [],
      label: this.value,
      prop_selopList: [],
      prop_mutSelList: "",
      allOption: {
        id: "0",
        label: "全部区服"
      },
      cache_key: ""
    };
  },
  created: function created() {
    this.initCacheKey();
    this.loadServerList();
    this.showSelectOptions();
  },
  methods: {
    initCacheKey: function initCacheKey() {
      if (this.isCache || this.readCacheType == 2) {
        if (this.multiple && this.multiple === true) {
          this.cache_key = "select_server_mult";
        } else {
          this.cache_key = "select_server";
        }
        if (this.all) {
          this.cache_key += "_all";
        }
      }
    },
    //获取选择框下拉列表
    loadServerList: function loadServerList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAvailableServerList();
            case 2:
              _this.serverList = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    showSelectOptions: function showSelectOptions() {
      console.log("是否是缓存", this.isCache, this.readCacheType);
      if (this.isCache || this.readCacheType == 2) {
        this.label = this.localCache.getCache(this.cache_key, this.multiple);
        if (this.multiple && this.multiple === true) {
          for (var i = 0; i < this.label.length; i++) {
            if (this.label[i] == "") {
              this.label = [];
            }
          }
        }
      }
      this.$emit("input", this.label);
    },
    someSelect: function someSelect() {
      if (this.isCache || this.readCacheType == 2) {
        this.localCache.setCache(this.cache_key, this.label);
      }
      this.$emit("input", this.label);
    }
  }
};